// 意大利
module.exports = {
  common: {
    edit: "modificare",
    apply: "Fare domanda a",
    activate: "Attivazione",
    delete: "eliminare",
    cancel: "Annulla",
    success: "successo",
    fail: "fallire",
    save: "salva",
    ensure: "Sicuro",
    submit: "invia",
    remark: "Osservazione",
    detail: "Controllo",
    action: "operare",
    open: "aprire",
    close: "chiusura",
    back: "ritorno",
    export: "esportare",
    modify: "Rivedere",
    layout: "disconnessione",
    noListData: "L'elenco non contiene dati",
    more: "Dettagli",
    add: "Aggiungere",
    delSuccess: "eliminato con successo!",
    addFailure: "aggiunta fallita!",
    logOut: "disconnettersi",
    delAllInfo: "Vuoi continuare l'operazione di eliminazione?",
    saveTip:
      "Non hai salvato il contenuto della pagina, vuoi continuare ad uscire?",
    tip: "suggerimento",
    yes: "SÌ",
    no: "NO",
    delTip: "Controlla per attivare",
    batchDelete: "cancellazione in blocco",
    search: "Chiedere informazioni",
    permission: "Ancora nessun permesso, per favore torna indietro",
    reset: "Ripristina",
  },
  breadcrumbItem: {
    home: "Configurazione elenco nomi",
    data: "Imballaggio di configurazione generale del dispositivo",
    alarm: "Configurazione zona",
    house: "Configurazione layout casa",
    name: "Configurazione elenco nomi",
  },
  errorRes: {
    res82: "Il sistema è occupato, riprova più tardi",
  },
  openConfig: {
    title: "Configurazione generale dispositivo",
    version: "Versione protocollo",
    versionTip: "Seleziona una versione del protocollo",
    checkVersion:
      "La versione del protocollo non può essere vuota, scegli di nuovo",
    signType: "Tipo di algoritmo di firma",
    checkSignType:
      "Il tipo di algoritmo di firma non può essere vuoto, scegliere di nuovo",
    fileLabel: "Seleziona un documento",
    addFile: "aggiungere i file",
    fileName: "nome del file",
    zipType: "Metodo di compressione",
    noZip: "nessuna compressione",
    noFile: "Nessun file aggiunto ancora",
    checkFile: "Il file di configurazione è vuoto, aggiungi un file",
    name: "nome",
    nameTip: "La lunghezza dell'input è di 1-10 cifre",
    checkName: "Il nome non può essere vuoto, inseriscilo nuovamente",
    checkName1: "Inserimento nome errato, inserire nuovamente",
    room: "ID del dispositivo",
    roomTip:
      "La lunghezza dell ' input è 1 - 24 bit e il livello è distinto da - ",
    checkRoom:
      "Il numero del dispositivo non può essere vuoto, inseriscilo nuovamente",
    checkRoom1:
      "L'inserimento del numero del dispositivo non è corretto, inserire nuovamente",
    pic: "immagine",
    add: "Aggiungere a",
    reset: "Ripristina",
    picTip: "La dimensione massima di caricamento di un file immagine è 3 m",
    checkPic: "Il file immagine non può essere vuoto, riselezionare",
    imgRegTip: "Carica solo file nei formati jpg, jpeg, png",
    excRegTip: "Carica solo file in formato xls e xlsx",
    zipRegTip: "Carica solo file in formato zip",
    produce: "Genera file di configurazione",
    confType: "Tipo di configurazione",
    pack: "Pacchetto",
    batchAdd: "Aggiungi gruppo",
    singleAdd: "Singola aggiunta",
    modelBatch: "Scarica modello di importazione batch",
    uploadInfo: "Carica informazioni di base Excel",
    uploadPic: "Carica il pacchetto di immagini Zip",
    addName: "Aggiungi un singolo dato",
    sameTip: "Numero di serie:",
    sameTip1: "Numero dispositivo duplicato",
    modelError:
      "Il contenuto del file di informazioni di base caricato non è corretto, modificare il file in base al modello",
    noPic:
      "Nell'elenco sono presenti dati che non sono stati aggiunti con le immagini, è necessario completare le immagini prima di generare il file di configurazione",
    picBtnTip: "Si prega di caricare prima il file delle informazioni di base",
    devType: "Tipo di apparecchiatura",
    devTypeTip: "Seleziona un tipo di dispositivo",
    checkDevType:
      "Il tipo di dispositivo non può essere vuoto, scegli di nuovo",
    indexName: "numero di serie",
    IS: "Unità interna",
    GU: "Macchina di gestione",
    OS1: "Stazione vocale",
    OS2: "Macchina da muro",
    OS3: "Stazione porta piccola",
    nameListTip:
      "Nei dati di base caricati, sono presenti dati con un campo del nome incompleto e il resto dei dati corretti è stato importato",
    numListTip:
      "Nei dati di base caricati, sono presenti dati incompleti nel campo del numero del dispositivo e il resto dei dati corretti è stato importato",
  },
  alarm: {
    ad: "Zona AD",
    io: "Zona IO",
    alarmPlus: "Espansione di zona",
    num: "numero di serie",
    open: "aprire",
    close: "vicino",
    machine: "Tipo di rilevatore",
    sendType: "Tipo di trigger",
    mode: "modello",
    mType1: "infrarosso",
    mType2: "Porta Magnetica",
    mType3: "magnete per finestre",
    mType4: "gas",
    mType5: "Fumo",
    mType6: "campanello di casa",
    mType7: "Pulsante Newsletter",
    mType8: "Sensore porta a infrarossi",
    mType9: "Sensore porta allarme manuale",
    mType10: "vibrazione",
    mType11: "pressione dell'aria",
    mType12: "altro",
    send1: "Segnala immediatamente entro 24 ore",
    send2: "Allarme ritardato",
    send3: "Ritardo di trasferimento",
    send4: "Chiama subito la polizia",
    send5: "Allarme incrociato",
    mode1: "Normalmente aperto",
    mode2: "Spesso spento",
    presence: "a casa",
    leaving: "lasciare casa",
    timeSet: "Impostazione dell'ora relativa al braccio",
    delayTime: "Ritardo effettivo inserimento (secondi)",
    startDelay: "Ritardo attivazione allarme (secondi)",
    startUtil: "Durata allarme (minuti)",
    associated: "Zona Associata",
  },
  house: {
    dev: "attrezzatura",
    scene: "Scene",
    vine: "sensore",
    single: "Controllo indipendente delle scene",
    light: "leggero",
    air: "condizionatore",
    heat: "Riscaldamento a pavimento",
    fresh: "Vento fresco",
    switch: "Presa interruttore",
    curtain: "tenda",
    water: "scaldabagno",
    bgm: "Musica di sottofondo",
    cust: "Dispositivo personalizzato",
    slight: "leggero",
    sAir: "condizionatore",
    sHeat: "Riscaldamento a pavimento",
    sFresh: "Vento fresco",
    sSwitch: "Presa interruttore",
    sCurtain: "tenda",
    sWater: "scaldabagno",
    sBgm: "Musica di sottofondo",
    sCust: "Dispositivo personalizzato",
    IndependentControl: "Controllo indipendente delle scene",
    scene1: "scena 1",
    scene2: "Scena 2",
    scene3: "Scena 3",
    scene4: "Scena 4",
    scene5: "Scena 5",
    scene6: "Scena 6",
    scene7: "Scena 7",
    scene8: "Scena 8",
    temp1: "temperatura",
    temp2: "umidità",
    temp3: "metano",
    temp4: "gas organico",
    picTip: "Non esiste una planimetria",
    upload: "Carica planimetria",
    imgSize:
      "La dimensione dell'immagine di una singola planimetria non deve superare i 10M",
    imgName:
      "Il nome del file della planimetria caricato non deve apparire in cinese, scegli di nuovo",
    imgLength:
      "Il numero totale di caricamenti e aggiunte di planimetrie non deve superare 8 e le prime 8 immagini nella cartella sono state selezionate automaticamente",
    imgCheckTip: "La planimetria non corrisponde, ricaricala",
    room1: "Casa Tipo 1",
    room2: "Casa Tipo 2",
    room3: "Casa Tipo 3",
    room4: "Casa Tipo 4",
    room5: "Casa Tipo 5",
    room6: "Casa Tipo 6",
    room7: "Casa Tipo 7",
    room8: "Tipo di casa Figura 8",
    download: "esportare",
    input: "Importa configurazione",
    title: "Tabella dei parametri dell'attrezzatura",
    name: "nome",
    location: "Posizione",
    start: "avviare",
    see: "visibile",
    noSee: "Invisibile",
    belong: "appartiene a",
    bgIcon: "Icona grigio blu",
    vineTip:
      "Selezionare la planimetria prima di impostare le proprietà di controllo della temperatura",
    sceneTip:
      "Seleziona la planimetria, quindi imposta le proprietà della scena",
    dragTip:
      "Selezionare la planimetria prima di eseguire l'operazione di trascinamento",
    editTip: "Modificato con successo",
    addTip:
      "Durante il caricamento, devi selezionare tutte le planimetrie contemporaneamente",
    editError:
      "Si prega di specificare il contenuto della modifica prima della modifica",
    delError: "Specificare il contenuto da eliminare prima dell'eliminazione",
    delTip: "eliminato con successo",
    imgAddTip:
      "Il numero totale di planimetrie caricate e aggiunte ha raggiunto 8 e non è possibile aggiungerne altre",
    houseTitle: "Commutazione mappa del tipo di casa:",
    delHouseTip:
      "Questa operazione eliminerà la planimetria e il contenuto della configurazione. Continuare?",
    sendTip:
      "Importa il contenuto della configurazione da modificare nuovamente, puoi caricare il file xml",
    checkType:
      "Il formato del file caricato è errato, controlla il contenuto del file e caricalo di nuovo",
    importTip: "Importa file di configurazione",
    importTip1: "Importa la planimetria corrispondente",
    upLoadBtn: "Caricamento",
    picContent:
      "L'ordine di caricamento delle planimetrie deve essere coerente con l'ordine delle planimetrie nel file di configurazione",
    successFile: "File di configurazione caricato correttamente",
    vineTipCheck: "Il nome non può essere vuoto, confermare l'inserimento",
    picNumMax:
      "Confermare il numero di immagini importate. Il numero attuale di immagini importate è superiore al numero di piante della casa nel file di configurazione. Selezionare nuovamente",
    picNumMin:
      "Confermare il numero di immagini importate. Il numero corrente di immagini importate è inferiore al numero di piante della casa nel file di configurazione. Scegliere di nuovo",
    maxSizeTip:
      "Il numero o il numero totale di aggiunte di questo tipo supera il limite. Se è necessario aggiungere, si prega di ordinare prima i dispositivi o le scene aggiunti.",
    devNameTip: "Inserisci un nome",
    chromeTip: "Si consiglia il browser Chrome",
    downTip: "Fare clic per passare al collegamento per il download",
    imgRegTip: "Carica solo file nei formati jpg e jpeg",
    threeTitle: "Tre sistema costante",
    mainControl: "maestro",
    sedControl: "sottocontrollo",
    controlBtn: "Configurazione",
    configEdit: "Dettagli sulla configurazione del sistema Sanheng",
    moveTip:
      "Trascina l'icona sull'area della planimetria, trascinala di nuovo",
    repeatNameTip:
      "Impossibile caricare planimetrie con lo stesso nome, selezionare di nuovo",
    space: "(Riservato)",
  },
  updateConfig: {
    tip0: "Quando si imposta la sveglia 24 ore, impostare l'interruttore su ON",
    tip1: "Quando si imposta la sveglia 24 ore, l'interruttore deve essere impostato su on",
    tip2: "Quando si imposta un allarme immediato, l'interruttore deve essere impostato su on",
    tip3: "Quando l'allarme di ritardo è disattivato, il ritardo di consegna deve essere disattivato",
    tip4: "L'allarme incrociato è stato impostato, è necessaria un'operazione associata",
    tip5: "Si prega di attivare prima l'allarme di ritardo",
    tip6: "Quando si imposta l'allarme immediato, impostare l'interruttore su on",
  },
  audio: {
    title: "Strumento di impacchettamento per indicazioni vocali",
    lock: "Suono di sblocco",
    call: "Suono di chiamata",
    speak: "Suono di chiamata in corso",
    busy: "Suono occupato",
    tip1: "Fare clic per caricare il file in formato .wav",
    tip2: "La dimensione del file non deve superare 1 MB",
    tip3: "Carica un file in formato .wav, per favore",
    tip4: "Carica tutti i file, per favore",
    add: "Generare file",
  },
  threeProject: {
    hotWater: "Sistema di riscaldamento acqua",
    cho: "Formaldeide",
    config: "Configurare",
    unconfig: "Non configurare",
  },
  elevator: {
    title: "Generatore Configurazione Controllo Ascensori",
    label: "Carica Tabella Configurazione Controllo Ascensori",
    uploadTip: "Fare clic o trascinare il file in questa area per caricarlo",
    upload: "Carica",
    download: "Scarica Modello",
    downloadTip:
      "Fare clic per scaricare il modello di tabella di configurazione del controllo ascensori",
    error1:
      "[Piano fisico] non valido. Verificare il file di configurazione e reimportarlo.",
    error2:
      "[Piano visualizzato] non valido. Verificare il file di configurazione e reimportarlo.",
    error3:
      "[Indirizzo gateway controllo ascensori] non valido. Verificare il file di configurazione e reimportarlo.",
    error4:
      "[Visualizzazione numero ascensore] non valida. Verificare il file di configurazione e reimportarlo.",
    error5:
      "[IP dispositivo] non valido. Verificare il file di configurazione e reimportarlo.",
    error6:
      "[Gateway controllo ascensori] numero limite superato. Verificare il file di configurazione e reimportarlo.",
    generate: "Modello Tabella Configurazione Controllo Ascensori",
    fileLabel: "File Configurazione Controllo Ascensori:",
    tip: "Inserire il file di configurazione nella sezione [Aggiornamento Risorse] dello strumento PC per importarlo nel dispositivo.",
    downloadfile: "Scarica",
    fileName: "ConfigurazioneControlloAscensori.xlsx",
    formatError:
      "Il formato del file caricato è errato. Verificare il contenuto del file e ricaricarlo.",
  },
};
